import React, { useEffect, useState } from 'react';
import API from "libs/api";
import { Modal, Button } from 'semantic-ui-react';
import { useParams } from "react-router-dom";
import { INPUT } from "components/cmp_form/cmp_form";
import ICON from "components/cmp_icon/cmp_icon";



export default function CMP_CONTACT_CREATE({ onOpen, onClose, onRefresh }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    const [ var_data, set_data ] = useState([]);
    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        let data = {...var_data};
        data.provider_id = provider_id;
        set_data(data);
    }, [ onOpen ]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function post_contact() {

        set_processing('processing');

        try {
            await API_post_contact();
            set_processing('inactive');
            onRefresh();
            onClose();
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_post_contact(){
        return API.post('admin-providers', '/post-provider-contact', { body: var_data});
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onChange_input(event){
        let data = {...var_data};
        data[event.target.name] = event.target.value;
        set_data(data);
    }

    function onClick_create(){
        post_contact();
    }

    function onClick_cancel(){
        onClose();
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='cmp_contact_create'>
            <div className='icon__wrapper'>
                <div className='icon'>
                    <ICON name='profile_female_1' className='icon' alt='contact icon'/>
                </div>
            </div>
            <div className="modal__header">
                <div className='text--md bold'>Add a new contact</div>
            </div>

            <div className='modal__content'>

                <div className='field__wrapper'>
                    <div className='field__label text--sm bold'>Contact type</div>
                    <div className='buttongroup'>
                        <div className='buttongroup__item'>Primary</div>
                        <div className='buttongroup__item active'>Other</div>
                    </div>
                </div>

                <INPUT
                    errors={[]}
                    label='Email'
                    name='email'
                    onChange={onChange_input}
                    placeholder=''
                    value={var_data.email || null}
                />

                <INPUT
                    errors={[]}
                    label='Phone'
                    name='phone'
                    onChange={onChange_input}
                    placeholder=''
                    value={var_data.phone || null}
                />

                <INPUT
                    errors={[]}
                    label='Name'
                    name='name'
                    onChange={onChange_input}
                    placeholder=''
                    value={var_data.name || null}
                />
            </div>

            <div className='modal__footer'>
                <Button className='primary' onClick={onClick_create}>Add</Button>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
            </div>
        </Modal>
    );
}